<div class="custom-modal">
    <div class="header">
      <h1 mat-dialog-title>
        {{titulo}}
      </h1>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
        <div [innerHTML]="data.texto"></div>
    </div>
    <form [formGroup]="filterForm">
        <input required formControlName="tempo" type="number" min="120" max="3600">
        <span style="color: red" *ngIf="filterForm.invalid || tempo < 120"> O tempo deve ser maior que 120 segundos</span>        
    </form>
    <div class="modal-actions" mat-dialog-actions align="end">
        <button mat-flat-button mat-dialog-close color="info" (click)="cancel()" >{{textoCancelar}}</button>
        <button [disabled]="filterForm.invalid || tempo < 120" mat-flat-button mat-dialog-close style="background-color: #cddc39" (click)="confirm()" >{{textoOk}}</button>
    </div>
  </div>
